module.exports = __webpack_public_path__ + "static/Logo english - yuva-ee8afcaf0f7ab7cc502d54264afa136c.png";